import styled from 'styled-components/macro'

export const DividerContainer = styled.ul`
  float: right;
  font-size: 12px;
`

export const DividerWrapper = styled.li`
  display: inline-block;
  padding-right: 10px;
  color: #d7d7d8;
`

export const DividerButton = styled.button<{ active?: boolean }>`
  border-style: none;
  background-color: inherit;
  color: ${(props) => (props.active ? '#0097FE' : '#003893')};
  font-family: roboto;
  font-weight: 400;
  white-space: nowrap;
  &:hover {
    color: #003893;
  }
  &:disabled {
    color: #9e9e9e;
    cursor: not-allowed;
  }
`
